import getPopularClients from '~/api/getPopularClients';
import { SelectBase } from './SelectBase';
import { withSelect2 } from './withSelect2';

export const Select2PopularClients = {
	name: 'Select2PopularClients',
	extends: SelectBase,
	mixins: [
		withSelect2((vm) => ({
			ajax: {
				transport: (params, success, failure) => {
					getPopularClients().then(success).catch(failure);
				},
				processResults: (results) => ({
					results: results.map?.((item) => ({
						...item,
						get id() {
							return this.ID
						},
						get text() {
							return this.NAME
						},
					})),
				}),
			},
			width: '100%',
		})),
	],
	watch: {
		value: {
			handler: function(clientId, oldClientId) {
				if (!clientId) return

				getPopularClients().then((clients) => {
					const client = clients.find((client) => client.ID === clientId)

					if (!client) return

					this.$options.select2.$element.append(new Option(client.NAME, client.ID))
				})
			},
			immediate: true,
		},
	},
}
